// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { PayoffContainer } from "../../_molecules/RacePayoffRunner/styled-components";

export const ResultsTable = styled.ul`
  list-style: none;
  width: 100%;
  ${(props) =>
    props.border &&
    css`
      border-bottom: 1px solid blue;
    `};
  background-color: ${buildColor("white", "100")};

  & > li {
    height: 48px;
  }
`;

export const NumberIcon = styled.div`
  height: 20px;
  width: 20px;
  background-color: ${buildColor("grey", "200")};
  color: ${buildColor("grey", "900")};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AwaitingContainer = styled(PayoffContainer)`
  padding: 14px 0;
`;

export const AwaitingLabel = styled.span`
  color: ${buildColor("grey", "900")};
  font-size: 14px;
  margin-left: 2px;
`;
